import { PageId } from 'constants/pages'
import { TStep } from 'nove8/types'

export const STEPS_WOOFZ_INVX: TStep[] = [
  {
    pageId: PageId.SUBSCRIPTIONS_INVOXIA_INVX,
  },
  {
    pageId: PageId.INVOXIA_CONGRATULATIONS_INVX,
  },
  {
    pageId: PageId.INVOXIA_REVIEW_INVX,
  },
  {
    pageId: PageId.INVOXIA_DETAILS_INVX,
  },
]
